package com.gloopgo.game.navigation

import androidx.navigation3.runtime.NavKey
import androidx.savedstate.serialization.SavedStateConfiguration
import kotlinx.serialization.Serializable
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic

@Serializable
data object SplashRoute : NavKey

@Serializable
data object HubRoute : NavKey

@Serializable
data object MainMenuRoute : NavKey

@Serializable
data object SinglePlayerMenuRoute : NavKey

@Serializable
data class ConnectingRoute(
    val playerName: String,
    val playerEmoji: String = "",
    val playerColor: Long? = null
) : NavKey

@Serializable
data class InGameRoute(
    val playerName: String,
    val useJoystick: Boolean = false,
    val playerEmoji: String = "",
    val playerColor: Long? = null,
    val isSinglePlayer: Boolean = false,
    val playerId: String? = null
) : NavKey

@Serializable
data class AvatarColorRoute(
    val isSinglePlayer: Boolean = false,
    val startAtAvatar: Boolean = false
) : NavKey

@Serializable
data object LeaderboardRoute : NavKey

@Serializable
data class SettingsRoute(val useJoystick: Boolean = false) : NavKey

val navConfig = SavedStateConfiguration {
    serializersModule = SerializersModule {
        polymorphic(NavKey::class) {
            subclass(SplashRoute::class, SplashRoute.serializer())
            subclass(HubRoute::class, HubRoute.serializer())
            subclass(MainMenuRoute::class, MainMenuRoute.serializer())
            subclass(SinglePlayerMenuRoute::class, SinglePlayerMenuRoute.serializer())
            subclass(ConnectingRoute::class, ConnectingRoute.serializer())
            subclass(InGameRoute::class, InGameRoute.serializer())
            subclass(AvatarColorRoute::class, AvatarColorRoute.serializer())
            subclass(LeaderboardRoute::class, LeaderboardRoute.serializer())
            subclass(SettingsRoute::class, SettingsRoute.serializer())
        }
    }
}
